var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length === 0)?_c('div',[_vm._v("\n    "+_vm._s(_vm.noInitialsText)+"\n")]):_c('div',_vm._l((_vm.items),function(item){return _c('report-specialist',{key:item.id,attrs:{"data":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }